import axios from "../api/axios";
import React, { useEffect, useState } from "react";

function UserHome() {
  const [poblacion, setPoblaciones] = useState([]);

  // Card poblaciones
  useEffect(() => {
    const fetchPoblaciones = async () => {
      try {
        const res = await axios.get("/api/tickets/poblaciones");
        setPoblaciones(res.data);
      } catch (error) {
        console.error("Error al obtener poblaciones:", error);
      }
    };

    fetchPoblaciones();
  }, []);

  return (
    <div className="w-full p-6 min-h-[calc(100vh-6rem)]">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
        {poblacion.map((e, index) => (
          <div
            key={index}
            className="flex flex-col justify-between bg-secondary-900 p-4 rounded-xl h-[50px] overflow-hidden"
          >
            <div className="flex justify-between items-center font-bold text-mid uppercase mb-2">
              <span>{e.poblacion}</span>
              <span>Nº Averías: {e.total}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserHome;
